import { IElement } from "core-integration/src/store/elements/types";
import { useState } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import styled from "styled-components";
import PlayMakerLogo from "../../img/logos/playmakerai.png";
import ElementCard from "../ElementCard";
import { Main, Wrapper } from "../Layout";
import Panel from "../Panel";
import Title from "../Title";
import XStatsElementList from "./ElementList/XStatsElementList";
import PlayerWidgetWithAd from "./PlayerWidget/PlayerWidgetWithAd";

const WidgetWrapper = styled.div`
  padding: ${({ theme }) =>
    `${theme.space[4]} ${theme.space[2]} ${theme.space[2]}`};
`;

const CardWrapper = styled.div`
  padding: ${({ theme }) => `0 ${theme.space[4]}`};

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    padding: ${({ theme }) => `${theme.space[5]} ${theme.space[3]} 0`};
  }
`;

const WidgetContainer = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    margin-top: ${({ theme }) => theme.space[4]};
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.colors.secondary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.secondary};
  margin-bottom: ${({ theme }) => theme.space[2]};
  padding: ${({ theme }) => theme.space[2]};
`;

const Image = styled.img`
  width: 60px;
  height: auto;
`;

const XStats: React.FC<WithTranslation> = ({ t }) => {
  const xstatsPlayerWidget = "xstats-player-widget";
  const [widgetVisible, setWidgetVisible] = useState(false);
  const [selectedElement, setSelectedElement] = useState<IElement | null>(null);
  const renderWidget = (element: IElement) => {
    setSelectedElement(element);
  };

  const hideWidget = () => {
    setSelectedElement(null);
    setWidgetVisible(false);
  };
  const elementFullname = selectedElement
    ? `${selectedElement.first_name} ${selectedElement.second_name}`
    : "";

  return (
    <Wrapper>
      <Main>
        <TitleWrapper>
          <Title>XStats</Title>
          <Image
            src={PlayMakerLogo}
            alt={t(
              "xStats.playmakerLogoAlt",
              "PlaymakerAI logo for Allsvenskan",
            )}
          />
        </TitleWrapper>
        <XStatsElementList
          renderWidget={renderWidget}
          widgetVisible={widgetVisible}
          hideWidget={hideWidget}
        />

        {selectedElement && (
          <WidgetContainer>
            <Panel>
              <Panel.Header title={elementFullname} />
              <Panel.Body>
                <CardWrapper>
                  <ElementCard element={selectedElement} />
                </CardWrapper>
                <WidgetWrapper>
                  <PlayerWidgetWithAd
                    selectorId={xstatsPlayerWidget}
                    element={selectedElement}
                    onWidgetChange={setWidgetVisible}
                  />
                </WidgetWrapper>
              </Panel.Body>
            </Panel>
          </WidgetContainer>
        )}
      </Main>
    </Wrapper>
  );
};

export default withTranslation()(XStats);
